export default __webpack_public_path__ + "static/media/p-logo-deep-saffron_invert_mm.32afca75.svg";